// SEND

export const IFRAME_RESIZE = 'iframe-resize';
export const STORE_WIDGET_SIZE_PREFERENCE = 'store-widget-size-preference';
export const IFRAME_RESIZE_DRAG_EXPAND = 'iframe-resize-drag-expand';
export const INPUT_TEXT_CHANGED = 'input-text-changed';
export const OPEN_CHANGE = 'open-change';
export const DRAG_HANDLE_POSITION_CHANGE = 'drag-handle-position-change';
export const RESTORE_SAVED_LAUNCHER_POSITION = 'restore-saved-launcher-position';
export const RESET_TO_DEFAULT_LAUNCHER_POSITION = 'reset-to-default-launcher-position';
export const CLOSED_WELCOME_MESSAGE = 'closed-welcome-message';
export const SCREEN_CAPTURE_REQUEST = 'screen-capture-request';
export const REQUEST_WIDGET = 'request-widget';
export const STORE_MESSAGES_COOKIE = 'store-messages-cookie';
export const SHOW_PAGE_TITLE_NOTIFICATION = 'show-page-title-notification';
export const CLEAR_PAGE_TITLE_NOTIFICATION = 'clear-page-title-notification';
export const START_TRACK_SCROLL_PERCENTAGE = 'start-track-scroll-percentage';
export const STOP_TRACK_SCROLL_PERCENTAGE = 'stop-track-scroll-percentage';
export const START_TRACK_EXIT_INTENT = 'start-track-exit-intent';
export const STOP_TRACK_EXIT_INTENT = 'stop-track-exit-intent';
export const API_REQUEST = 'api-request';
export const I18N_LABELS = 'i18n-labels';

// RECEIVE

export const WIDGET_SIZE_PREFERENCE = 'widget-size-preference';
export const WIDGET_DATA = 'widget-data';
export const HUBSPOT_UTK = 'hubspot-utk';
export const GLOBAL_COOKIE_OPT_OUT = 'global-cookie-opt-out';
export const SCREEN_CAPTURE_BLOB = 'screen-capture-blob';
export const FIRST_VISITOR_SESSION = 'first-visitor-session';
export const REFRESH_WIDGET_DATA = 'refresh-widget-data';
export const REQUEST_OPEN = 'request-open';
export const REQUEST_CLOSE = 'request-close';
export const BROWSER_WINDOW_RESIZE = 'browser-window-resize';
export const SCROLL_PERCENTAGE_CHANGE = 'scroll-percentage-change';
export const EXIT_INTENT = 'exit-intent';
export const PERF_ATTRIBUTES = 'perf-attributes';
export const TRACK_API_USAGE = 'track-api-usage';
export const TRACK_WIDGET_DRAGGED = 'track-widget-dragged';
export const OPEN_TO_NEW_THREAD = 'open-to-new-thread';
export const API_REQUEST_RESULT = 'api-request-result';
export const VISITOR_IDENTIFICATION_ATTRIBUTES = 'visitor-identification-attributes';
export const KB_RELATED_ARTICLE_CLICKED = 'kb-related-article-clicked';
export const SPEECH_POC = 'speech-poc';
export const ENTRY_URL_METADATA = 'entry-url-metadata';
export const SET_INPUT_TEXT = 'set-input-text';
export const OPEN_TO_KB_CONTENT = 'open-to-kb-content';